import React from 'react'
import EditableHOCWrapper from '../../containers/HOC/EditableHOC'
import MetrcMergedNewItem from './MetrcMergedNewItem'

const BiotrackNewItemEditable = EditableHOCWrapper(MetrcMergedNewItem)

export default class MetrcMergedNewItemContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      editMode: false,
      data: {
        stateCode: '',
        environment: 'Development',
        shopId: this.props.shop.id,
        userApiKey: '',
        facLicense: '',
        enabled: false,
        enableSync: false,
        enableDeliveryTransaction: false,
      },
    }
  }

  onCancel = () => {
    //Clear data after cancel.
    this.setState({
      data: {
        stateCode: '',
        environment: 'Development',
        shopId: this.props.shop.id,
        userApiKey: '',
        facLicense: '',
        enabled: false,
        enableSync: false,
        enableDeliveryTransaction: false,
      },
    })
  }

  render() {
    const { editMode, data } = this.state

    const { onAddNewFacility } = this.props

    const location = data
    return (
      <BiotrackNewItemEditable
        dataToEdit={location}
        onSave={this.onSave}
        onCancel={this.onCancel}
        defaultEditMode={editMode}
        onAddNewLocation={onAddNewFacility}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Compliance/MetrcMergedNewItemContainer.js